export default __webpack_public_path__ + "static/media/pcs_logo.affc508e.png";